export default __webpack_public_path__ + "static/media/Icons_15.76dbbc17.svg";